import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { has } from 'lodash';
import { withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { Button } from '../../uiStandard/event/button';

class SelectLanguageDropdown extends Component {
  state = { langActive: 'EN' };

  componentDidMount() {
    const { activeLanguage } = this.props;
    if (has(activeLanguage, 'code')) {
      if (activeLanguage.code !== 'en') {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ langActive: 'CN' });
      }
    }
  }

  handleSetLanguage = (langCode) => {
    if (langCode === 'en') {
      this.props.setActiveLanguage('zh-Hans');
      localStorage.setItem('language', 'zh-Hans');
    } else {
      this.props.setActiveLanguage('en');
      localStorage.setItem('language', 'en');
    }
  }


  render() {
    const { activeLanguage, match, translate } = this.props;
    const { path } = match;

    const isHomePage = path === '/';

    return (
      <Fragment>
        <ButtonWrapper>
          <NavButton
            isPrimary={false} isSmall
            label={translate('button.lang')}
            onClick={() => this.handleSetLanguage(activeLanguage.code)}
            isHomePage={isHomePage ? !this.props.navColor : false}
          />
        </ButtonWrapper>
        <StyledList>
          <NavButton
            isPrimary={false} isSmall
            label={translate('button.lang')}
            onClick={() => this.handleSetLanguage(activeLanguage.code)}
            isHomePage={false}
          />
        </StyledList>
      </Fragment>
    );
  }
}

const ButtonWrapper = styled.li`
  padding-left: 32px;

  @media only screen and (max-width: 430px) {
    padding-left: 1em;
  }
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledList = styled.li`
  display: none;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #666666;
  padding: 0.8em 0;

  :hover {
    color: #0095FA;
  }

  button {
    width: 50%;
  }

  @media only screen and (max-width: 387px) {
    li {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: 768px) {
    display: block;
  }

`;

const NavButton = styled(Button)`
  border: ${props => (props.isHomePage ? '1px solid #fff' : '1px solid #0094FB')};
  color: ${props => (props.isHomePage ? '#fff' : '#0094FB')};

  :hover {
    color: #fff;
  }

  @media only screen and (max-width: 430px) {
    font-size: 14px;
  }
`;

export default compose(withLocalize, withRouter)(SelectLanguageDropdown);



// WEBPACK FOOTER //
// ./src/components/nav/selectLanguageDropdown.js